import React from 'react';
import { motion } from 'framer-motion';

interface FloatingActionButtonProps {
  onClick?: () => void;
  Icon: React.FC<{ className: string }>;
}

export const FloatingActionButton: React.FC<FloatingActionButtonProps> = ({
  children,
  Icon,
  onClick,
}) => {
  return (
    <div className="absolute bottom-0 left-0 z-40 w-16 h-16 p-3 ml-48">
      <motion.button
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
        exit={{}}
        className="flex items-center justify-center w-full h-full text-3xl font-bold text-white rounded-full shadow bg-jcap-500 hover:bg-jcap-400 active:shadow-none"
        onClick={onClick}
      >
        <Icon className="w-10 h-10" />
      </motion.button>
    </div>
  );
};

export default FloatingActionButton;
